module.exports = __webpack_public_path__ + "static/media/07_Jule.cc805c5b.png";